import BASEURLGESTTOR from '../api/gesttor'

export function processosRealizadosMes() {
  return BASEURLGESTTOR.get('/dashboard/processoSeletivo/realizados')
}

export function tempoMedioExecucao() {
  return BASEURLGESTTOR.get('/dashboard/processoSeletivo/tempoMedioExecucao')
}

export function processoSeletivoPrazoAoMes() {
  return BASEURLGESTTOR.get('/dashboard/processoSeletivo/processosPorPrazo')
}

export function processoSeletivoPrazoAnual() {
  return BASEURLGESTTOR.get('/dashboard/processoSeletivo/processosPorPrazoAno')
}

export function quantidadeProcessosNps() {
  return BASEURLGESTTOR.get('/dashboard/processoSeletivo/quantidadeProcessosNps')
}

export function situacaoProcessoSeletivo() {
  return BASEURLGESTTOR.get('/dashboard/processoSeletivo/situacao')
}